<template>
  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 edit_account_modal">
    <div class="my-account-title">Communication and Contract Information</div>
    <div class="account_section_box">
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <label class="account_label">Account Communication Preferences</label>
          <div class="form-check">
            <div>
              <input class="form-check-input" type="checkbox" v-model="AccountEdit.toBeContactedAsVolunteer">
              <span class="account_p">I would like to be contacted if there are volunteer opportunities in my area.</span>
            </div>
            <div>
              <input class="form-check-input" type="checkbox" v-model="AccountEdit.toReceiveNewsLetter">
              <span class="account_p">I would like email updates from OneSight EssilorLuxottica Foundation.</span>
            </div>
          </div>
          <br>
          <label class="account_label">Program Contract</label>
          <br>
          <span class="account_p">
            <a class="g-font-size-18" v-on:click="GeneratePdf()">Click here</a> 
            <span v-if="isContractLoading">
                <img src="../../../../../static/img/loading.gif" style="width: 25px"/>
            </span>
            to download a copy of your contract.</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['AccountEdit', 'CheckboxBusiness', 'CheckboxIndividual', 'FormInputs'],
  data(){
    return{
      isContractLoading: false      
    }
  },
  methods: {
    GeneratePdf() {
      var _this = this;
      _this.isContractLoading = true;
      var salesforceId = _this.AccountEdit.salesforceId;
      axios.get("/Account/GetContractBySalesforceId/" + salesforceId, {
      headers: { Authorization: "Bearer " + localStorage.getItem("token") }
      })
      .then(function(response) {
          var result = response.data.raw;
          var link = document.createElement("a");
          link.href = result;
          link.target = "_blank";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          _this.isContractLoading = false;
      })
      .catch(function(error) {
        console.log(error);
        _this.$router.push({name: 'Error'});
      });
    }
  }
}
</script>



// WEBPACK FOOTER //
// EditCommunicationInfo.vue?204ee8e8